import type React from 'react';
import styled from 'styled-components';
import { GREY_800 } from '../../theme/colors';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 0.375rem;
  i {
    flex-shrink: 0;
    height: ${({ theme }) => theme.sizingIconXxs};
    width: ${({ theme }) => theme.sizingIconXxs};
  }
  p {
    margin: 0;
    color: ${GREY_800};
    font-size: 0.75rem; 
    line-height: 1.125rem
  }
`;

type Props = {
  text: string;
  icon: React.ReactNode;
  className?: string;
};

const Helper: React.FC<Props> = ({ text, icon, className }) => (
  <Wrapper className={className}>
    {icon}
    <p>{text}</p>
  </Wrapper>
);

export default Helper;
